module.exports = __webpack_public_path__ + "img/color8.a856bebb.png";